/*
 * EVITAS — mm-perso-sync.js (6.10.2026)
 * Uskladi doplačila za personalizacijo (PRINT/LASER), ki jih doda blok
 * mix & match, z izdelkom, ki mu pripadajo.
 *
 * Mix & match vsakemu izdelku in njegovemu doplačilu da isto skrito lastnost
 * `_mm_link`; doplačilo ima še `_mm_fee: 1`. Ta skripta ob vsaki spremembi
 * košarice poskrbi, da je količina doplačila enaka količini izdelka:
 *   - kupec zmanjša/poveča izdelek  -> doplačilo sledi
 *   - kupec izdelek odstrani         -> doplačilo se odstrani
 *   - kupec ročno spremeni doplačilo -> vrne se na količino izdelka
 * Vrstic brez `_mm_link` (Aris, stare košarice) se ne dotika.
 * Isto uporablja blok personalizacije (predloge/personalizacija.liquid):
 * izdelek nosi `_mm_link` (pri setu več povezav, ločenih z vejico),
 * vsako doplačilo pa svojo povezavo in `_mm_fee: 1`.
 *
 * VAROVALKA (16.10.2026): kupec doplačila za personalizacijo ne more odstraniti
 * mimogrede — pred izbrisom vrstice dobi vprašanje (z imenom, ki bi bilo
 * izbrisano), količine doplačila pa ne more spreminjati (sledi izdelku).
 * Navadnih vrstic in vrstic brez `_mm_fee` se varovalka ne dotika.
 */
(function () {
  'use strict';
  if (window.__mmPersoSync) return;
  window.__mmPersoSync = true;

  var busy = false;
  var again = false;

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function sectionsToUpdate() {
    var sections = [];
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );
    } catch (e) { /* ignore */ }
    return sections;
  }

  // Vrne {lineKey: novaKolicina} ali null, če je vse usklajeno.
  function plan(cart) {
    var parentQty = {};
    var feesByLink = {};
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      var link = p._mm_link;
      if (!link) return;
      if (p._mm_fee) {
        (feesByLink[link] = feesByLink[link] || []).push(it);
      } else {
        // Set ima na ISTI vrstici več doplačil (nahrbtnik + steklenička), zato
        // zna izdelek nositi več povezav, ločenih z vejico (Eva 13.10.2026).
        String(link).split(',').forEach(function (l) {
          var k = l.trim();
          if (k) { parentQty[k] = (parentQty[k] || 0) + it.quantity; }
        });
      }
    });
    var updates = {};
    var n = 0;
    Object.keys(feesByLink).forEach(function (link) {
      var want = parentQty[link] || 0;
      feesByLink[link].forEach(function (fee, i) {
        var q = i === 0 ? want : 0;   // en sam vnos doplačila na izdelek
        if (fee.quantity !== q) { updates[fee.key] = q; n++; }
      });
    });
    return n ? updates : null;
  }

  // Kupec je doplačilo izbrisal iz košarice: z izdelka pobrišemo napise, ki so
  // pripadali temu doplačilu (Eva 13.10.2026). Katere, pove `_apo_polja`
  // (povezava -> ključi), ki ga zapiše blok personalizacije; vrstic brez njega
  // (mix & match, Aris, stare košarice) se ne dotaknemo.
  function ocisti(cart) {
    var zivi = {};
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (p._mm_link && p._mm_fee && it.quantity > 0) { zivi[p._mm_link] = true; }
    });
    var posli = [];
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (!p._apo_polja || p._mm_fee) { return; }
      var karta;
      try { karta = JSON.parse(p._apo_polja); } catch (e) { return; }
      var odpadli = [];
      var ostali = [];
      Object.keys(karta).forEach(function (link) {
        if (zivi[link]) { ostali.push(link); } else { odpadli.push(link); }
      });
      if (!odpadli.length) { return; }
      var brez = {};
      odpadli.forEach(function (link) {
        (karta[link] || []).forEach(function (k) { brez[k] = true; });
      });
      var nove = {};
      Object.keys(p).forEach(function (k) {
        if (brez[k]) { return; }
        nove[k] = p[k];
      });
      if (ostali.length) {
        var preostala = {};
        ostali.forEach(function (link) { preostala[link] = karta[link]; });
        nove._apo_polja = JSON.stringify(preostala);
        nove._mm_link = ostali.join(',');
      } else {
        // nobenega doplačila več: izdelek ostane, personalizacije ni
        ['_apo_polja', '_mm_link', '_has_apo', '_apo_order', '_apo_kosi'].forEach(function (k) {
          delete nove[k];
        });
      }
      posli.push({ id: it.key, quantity: it.quantity, properties: nove });
    });
    return posli;
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        kosarica = cart;
        oznaci();
        var posli = ocisti(cart);
        if (posli.length) {
          // /cart/change.js zna naenkrat spremeniti eno vrstico — gremo zaporedno
          return posli.reduce(function (p, posel) {
            return p.then(function () {
              return fetch(rootUrl() + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(posel)
              });
            });
          }, Promise.resolve()).then(function () { again = true; });
        }
        var updates = plan(cart);
        if (!updates) return null;
        return fetch(rootUrl() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, sections: sectionsToUpdate() })
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (window.FoxTheme && FoxTheme.pubsub) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                source: 'mm-perso-sync',
                cart: state
              });
            }
          });
      })
      .catch(function (e) { console.warn('[mm-perso-sync]', e); })
      .then(function () {
        busy = false;
        if (again) { again = false; sync(); }
      });
  }

  function onCartChange(data) {
    if (data && data.source === 'mm-perso-sync') return;   // naša lastna sprememba
    sync();
  }

  // ----------------------------------------------------------------------
  // Varovalka pri odstranitvi doplačila (Eva 16.10.2026: »stranka dobi
  // opozorilo, ko odstrani personalizacijo iz košarice«).
  // Gumb za odstranitev v temi je <a is="cart-remove-item" data-index="N">
  // znotraj vrstice z `data-line-key`. Klik lovimo v fazi zajema, pred temino
  // obravnavo; če vrstica NI doplačilo (`_mm_fee`), se ne zgodi nič — dogodek
  // gre nemoteno naprej. Pri doplačilu vprašamo in po potrditvi ponovimo klik.
  // ----------------------------------------------------------------------
  var kosarica = null;        // zadnje znano stanje košarice (iz sync)
  var preskoci = false;       // ponovljen klik po potrditvi ne sme znova vprašati

  var BESEDILA = {
    sl: 'Odstranim personalizacijo{ime}? Vpisano besedilo bo izbrisano, doplačilo odpade.',
    hr: 'Ukloniti personalizaciju{ime}? Upisani tekst bit će izbrisan, doplata otpada.',
    it: 'Rimuovere la personalizzazione{ime}? Il testo inserito verrà eliminato e il supplemento non verrà addebitato.',
    de: 'Personalisierung{ime} entfernen? Der eingegebene Text wird gelöscht, der Aufpreis entfällt.',
    fr: 'Supprimer la personnalisation{ime} ? Le texte saisi sera effacé et le supplément ne sera pas facturé.',
    en: 'Remove the personalization{ime}? The text you entered will be deleted and the surcharge will not be charged.'
  };
  var JE_DA = /^(da|yes|sì|si|ja|oui|tak|sim)$/i;

  function jezik() {
    var l = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
    l = String(l).toLowerCase().slice(0, 2);
    return BESEDILA[l] ? l : 'en';
  }

  function jeDoplacilo(it) {
    return !!(it && it.properties && it.properties._mm_fee);
  }

  // Vrstico poiščemo po ključu (zanesljivo), sicer po zaporedni številki.
  function poisci(cart, kljuc, indeks) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (kljuc && items[i].key === kljuc) { return items[i]; }
    }
    return (!kljuc && indeks > 0 && items[indeks - 1]) || null;
  }

  // Vprašanje za doplačilo; vpisano besedilo vzamemo z izdelka, ki nosi isto povezavo.
  function vprasanje(cart, doplacilo) {
    var link = doplacilo.properties._mm_link;
    var imena = [];
    (cart.items || []).forEach(function (x) {
      var q = x.properties || {};
      if (q._mm_fee || !q._apo_polja) { return; }
      var karta;
      try { karta = JSON.parse(q._apo_polja); } catch (e) { return; }
      (karta[link] || []).forEach(function (k) {
        var v = q[k];
        if (v && !JE_DA.test(String(v).trim()) && imena.indexOf(v) < 0) { imena.push(v); }
      });
    });
    return BESEDILA[jezik()].replace('{ime}', imena.length ? ' »' + imena.join(', ') + '«' : '');
  }

  function osveziKosarico() {
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { kosarica = c; oznaci(); return c; });
  }

  function onRemoveClick(e) {
    if (preskoci || !e.target || !e.target.closest) { return; }
    var a = e.target.closest('a[is="cart-remove-item"]');
    if (!a) { return; }
    var vrstica = a.closest('[data-line-key]');
    var kljuc = vrstica ? vrstica.getAttribute('data-line-key') : '';
    var indeks = parseInt(a.getAttribute('data-index'), 10) || 0;
    var znan = kosarica ? poisci(kosarica, kljuc, indeks) : null;
    if (znan && !jeDoplacilo(znan)) { return; }   // navadna vrstica: brez zadrževanja

    e.preventDefault();
    e.stopImmediatePropagation();
    function naprej(cart) {
      var it = poisci(cart, kljuc, indeks);
      if (jeDoplacilo(it) && !window.confirm(vprasanje(cart, it))) { return; }
      // vrstica se je med čakanjem lahko izrisala znova — gumb poiščemo na novo
      var cilj = (kljuc && document.querySelector('[data-line-key="' + kljuc + '"] a[is="cart-remove-item"]')) || a;
      preskoci = true;
      try { cilj.click(); } finally { preskoci = false; }
    }
    if (znan) { naprej(kosarica); return; }
    osveziKosarico().then(naprej).catch(function () { naprej(null); });
  }

  // Količine doplačila kupec ne spreminja: sledi izdelku (plan()). Zmanjšanje na 0
  // bi doplačilo odstranilo mimo vprašanja, zato krmilo na vrstici onemogočimo.
  function oznaci() {
    if (!kosarica) { return; }
    var doplacila = {};
    (kosarica.items || []).forEach(function (it) { if (jeDoplacilo(it)) { doplacila[it.key] = true; } });
    Array.prototype.forEach.call(document.querySelectorAll('[data-line-key]'), function (v) {
      var je = !!doplacila[v.getAttribute('data-line-key')];
      v.classList.toggle('ev-doplacilo', je);
      Array.prototype.forEach.call(v.querySelectorAll('quantity-input'), function (q) {
        if (je) {
          q.setAttribute('inert', '');
          q.style.opacity = '.55';
        } else if (q.hasAttribute('inert')) {
          q.removeAttribute('inert');
          q.style.opacity = '';
        }
      });
    });
  }

  function opazuj() {
    if (!window.MutationObserver || !document.body) { return; }
    var cakaj = null;
    new MutationObserver(function () {
      clearTimeout(cakaj);
      cakaj = setTimeout(oznaci, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, onCartChange);
    }
    // mix & match po dodajanju sproži ta dva dogodka
    document.addEventListener('cart:updated', function () { sync(); });
    document.documentElement.addEventListener('cart:refresh', function () { sync(); });
    // ob nalaganju strani (tudi vrnitev z »nazaj«)
    window.addEventListener('pageshow', function () { sync(); });
    document.addEventListener('click', onRemoveClick, true);
    opazuj();
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

